import Field from "../fields/Field";
import { Icons } from "../../../misc/Icons";
import { Button, IconButton } from "@mui/material"
import { FormFieldOutput } from "../../../models/Interfaces";
import { format, isValid } from "date-fns";
import { UTCDate } from "@date-fns/utc";


export default function IllegalPresenceTable ({periodStart, periodEnd, rows, onChange = (newRows) => {}}) {

    const addIllegalPresence = () => {
        onChange(
            [...rows, {
                FromDate: null,
                ToDate: null,
                Certainty: "CERTAIN"
            }]
        )
    }

    const removeIllegalPresence = (index: number) => {
        onChange([...rows.filter((row, r) => r !== index)])
    }

    const handleIllegalPresenceChange = (rowIndex: number, fieldOutput: FormFieldOutput) => {
        var table = [...rows]
        table[rowIndex][fieldOutput.name] = fieldOutput.value
        console.log(rows, fieldOutput)
        onChange(table)
    }
    
    return (
        <div>
            <table className="illegal-presence-table">
                <thead>
                    <tr>
                        <td></td>
                        <td>From</td>
                        <td>To</td>
                        <td></td>
                        <td></td>
                        <td>Certainty</td>
                        <td></td>
                    </tr>
                </thead>

                <tbody>
                    {rows.map((rowData: any, index: number) => {

                        var fromDate = new UTCDate(rowData.FromDate)
                        var toDate = new UTCDate(rowData.ToDate)

                        return (
                            <tr key={index}>
                                <td style={{width: 0, paddingRight: "0px"}}>{index + 1}</td>
                                <td style={{width: "110px"}}>
                                    <Field.Date
                                        name="FromDate"
                                        value={fromDate && isValid(fromDate) ? format(fromDate, "yyyy-MM-dd") : null}
                                        warning={false}
                                        minDate={periodStart}
                                        maxDate={toDate && isValid(toDate) ? toDate : periodEnd}
                                        onChange={(e) => {
                                            handleIllegalPresenceChange(index, {name: "FromDate", value: new UTCDate(e.target.value)})
                                        }} />
                                </td>
                                <td style={{width: "110px"}}>
                                    <Field.Date
                                        name="ToDate"
                                        value={toDate && isValid(toDate) ? format(toDate, "yyyy-MM-dd") : null}
                                        warning={false}
                                        minDate={fromDate && isValid(fromDate) ? fromDate : periodStart}
                                        maxDate={periodEnd}
                                        onChange={(e) => {
                                            handleIllegalPresenceChange(index, {name: "ToDate", value: new UTCDate(e.target.value)})
                                        }} />
                                </td>
                                <td></td>
                                <td></td>
                                <td style={{width: "70px"}}>
                                    <Field.Select
                                        name="Certainty"
                                        value={rowData.Certainty}
                                        warning={false}
                                        onChange={(fieldOutput: FormFieldOutput) => handleIllegalPresenceChange(index, fieldOutput)}
                                        options={[
                                            {value: "CERTAIN", label: "Certain"},
                                            {value: "DOUBTFUL", label: "Likely"}
                                        ]} />
                                </td>
                                <td style={{width: "15px"}}>
                                    <IconButton style={{padding: "0"}}>
                                        <Icons.X onClick={() => removeIllegalPresence(index)} />
                                    </IconButton>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            
            <Button variant="contained" className="btn btn-sm" onClick={() => addIllegalPresence()}>Add Illegal presence</Button>
        </div>
    )
}